import { Button, Typography } from '@mui/material';
import classNames from 'classnames';
import { Field, Form, Formik } from 'formik';
import CountryHero from './components/CountryHero';
import FormikCountriesSelect from './components/FormikCountriesSelect';
import FormikSelect from './components/FormikSelect';
import ValidationErrors from './components/ValidationErrors';
import { formInitialValues, typeOptions } from './RoamingMainForm.consts';
import styles from './RoamingMainForm.module.scss';
import { formValidationSchema } from './RoamingMainForm.utils';
import useRoamingMainForm from './useRoamingMainForm';

const RoamingMainForm = ({ countries, flags, banners, selectedCountry, onSubmit }) => {
  const { language, labels, isLoading, countriesOptions, submitHandler } = useRoamingMainForm(
    countries,
    flags,
    banners,
    onSubmit
  );

  return (
    <Formik
      validateOnMount={false}
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={formInitialValues}
      validationSchema={formValidationSchema(labels)}
      onSubmit={submitHandler}
    >
      {({ isSubmitting }) => (
        <Form className={styles.container}>
          <div className={styles.heroContainer}>
            <CountryHero className={styles.heroImg} country={selectedCountry} />
            <div className={styles.hero}>
              <Typography component="div" variant="h5" color="white" textAlign="center" className="pt-2 pb-3">
                {labels?.form?.title}
              </Typography>
              <Typography component="div" variant="h4" color="white" textAlign="center" className="pb-4">
                {labels?.form?.subtitle}
              </Typography>
              <div className="row g-4">
                <div
                  className={classNames('col-12 col-lg', {
                    'opacity-50': isLoading || isSubmitting,
                  })}
                >
                  <Field name="country">
                    {(props) => (
                      <FormikCountriesSelect
                        {...props}
                        placeholder={labels?.form?.countryPlaceholder}
                        searchPlaceholder={labels?.form?.submit}
                        isLoading={isLoading}
                        options={countriesOptions}
                        language={language}
                        emptyOptionsMessage={labels?.form?.emptyOptionsMessage}
                        emptySearchMessage={labels?.form?.emptySearchMessage}
                      />
                    )}
                  </Field>
                </div>
                <div
                  className={classNames('col-12 col-lg', styles.contractColumn, {
                    'opacity-50': isLoading || isSubmitting,
                  })}
                >
                  <Field name="type">
                    {(props) => (
                      <FormikSelect {...props} options={typeOptions} isLoading={isLoading} language={language} />
                    )}
                  </Field>
                  <ValidationErrors className={styles.errorMsg} locale={language} />
                </div>
                <div
                  className={classNames('col-12 col-lg-auto d-flex align-items-center', {
                    'opacity-50': isLoading,
                  })}
                >
                  <Button
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    disableElevation
                    disabled={isLoading || isSubmitting}
                    loading={isSubmitting}
                    type="submit"
                    variant="contained"
                    className="rounded-5 px-4 py-2 w-100"
                    sx={{
                      ':focus': { outline: 'none' },
                      ':focus-visible': { outline: '2px solid black', outlineOffset: '3px' },
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className={styles.loadingText}>{labels?.form?.submit}</span>
                        <span className={styles.loaderWrapper}>
                          <span className={styles.loader} />
                        </span>
                      </>
                    ) : (
                      labels?.form?.submit
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
export default RoamingMainForm;
